import { useNavigate, useParams } from "react-router-dom"
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import useApi from "../../hooks/ApiHook";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import useToast from "../../hooks/ToastHook";
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from "primereact/dropdown";
import InputSearchSidebar from "../../components/InputSearchSidebar";
import { Sidebar } from "primereact/sidebar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const cstOrigins = [{
    number: 0,
    description: 'Nacional, exceto as indicadas nos códigos 3 a 5'
}, {
    number: 1,
    description: 'Estrangeira - Importação direta, exceto a indicada no código 6'
}, {
    number: 2,
    description: 'Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7'
}, {
    number: 3,
    description: 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%'
}, {
    number: 4,
    description: 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967 , e as Leis nºs 8 248/1991, 8.387/1991, 10.176/2001 e 11.484/2007'
}, {
    number: 5,
    description: 'Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%'
}, {
    number: 6,
    description: 'Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural'
}, {
    number: 7,
    description: 'Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural'
}];

export default function() {

    const { id } = useParams();
    const navigate = useNavigate();
    const api = useApi();
    const { showSuccess, showAxiosError } = useToast();
    const [ loading, setLoading ] = useState(true);
    const [ saving, setSaving ] = useState(false);
    const [ product, setProduct ] = useState({});
    const [ ncm, setNcm ] = useState();
    const [ ncmExceptionList, setNcmExceptionList ] = useState();
    const [ ncmException, setNcmException ] = useState();
    const [ cest, setCest ] = useState();
    const [ unitSet, setUnitSet ] = useState();
    const isNew = id === 'new';

    useState(() => {
        if (isNew) {
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get('products/' + id).then(({ data }) => {
            setProduct(data);
            setNcm(data.ncm);
            setCest(data.cest);
            setUnitSet(data.unitSet);
        }).finally(() => setLoading(false));
    }, [id]);

    useEffect(() => {
        if (ncm && ncm.exceptions && ncm.exceptions.length) {
            setNcmExceptionList(ncm.exceptions);
        } else {
            setNcmExceptionList(null);
        }
    }, [ncm]);

    const save = e => {
        setSaving(true);

        const saveRequest = {
            description: product.description,
            code: product.code,
            eanCode: product.eanCode,
            ncm: ncm,
            ncmException: ncmException,
            cest: cest,
            cstOrigin: product.cstOrigin,
            unitSet: unitSet
        }

        const request = isNew ? api.post('products', saveRequest) : api.put('products/' + id, saveRequest);

        request.then(() => {
            showSuccess('Salvo com sucesso');
            navigate(-1);
        }).catch(showAxiosError).finally(() => setSaving(false));
        
        e.preventDefault();
    }

    const ncmDropdownItemTemplate = (item) => (
        <div>
            <div className="font-semibold">{item.formattedCode}</div>
            <div className="text-sm" style={{ maxWidth: 300, whiteSpace: 'break-spaces' }}>{item.description}</div>
        </div>
    );

    const cstDropdownItemTemplate = (item) => (
        <div>
            <div className="font-semibold">{item.number}</div>
            <div className="text-xs" style={{ maxWidth: 300, whiteSpace: 'break-spaces' }}>{item.description}</div>
        </div>
    );

    return (
        <div>
            <PageTitle title={`${isNew ? 'Novo' : 'Edição de'} Produto`}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <form onSubmit={save}>
                        <div className="formgrid grid">
                            <div className="field col-12">
                                <label>Descrição</label>
                                <InputText
                                    type="text"
                                    value={product.description || ''}
                                    maxLength={50}
                                    onChange={e => setProduct({ ...product, description: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Código externo</label>
                                <InputText
                                    value={product.code || ''}
                                    maxLength={30}
                                    onChange={e => setProduct({ ...product, code: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Código de barras</label>
                                <InputText
                                    value={product.eanCode || ''}
                                    maxLength={13}
                                    onChange={e => setProduct({ ...product, eanCode: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label>NCM</label>
                                <InputSearchSidebar
                                    title="Buscar NCM"
                                    placeholder="Buscar NCM"
                                    searchPath="ncm"
                                    searchParam="search"
                                    optionTemplate={ncmDropdownItemTemplate}
                                    valueTemplate={ncm => ncm.description}
                                    getKey={ncm => ncm.code}
                                    onChange={ncm => setNcm(ncm)}
                                    value={ncm}
                                    inputClassName="w-full"/>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label>Exceção da NCM</label>
                                <Dropdown
                                    options={ncmExceptionList}
                                    value={ncmException}
                                    optionLabel="description"
                                    dataKey="number"
                                    disabled={!ncmExceptionList}
                                    onChange={e => setNcmException(e.value)}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label>CEST</label>
                                <CestDropdown
                                    value={cest}
                                    ncm={ncm}
                                    onChange={setCest}/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Origem CST</label>
                                <Dropdown
                                    options={cstOrigins}
                                    value={{ number: product.cstOrigin }}
                                    optionLabel="description"
                                    dataKey="number"
                                    itemTemplate={cstDropdownItemTemplate}
                                    onChange={e => setProduct({ ...product, cstOrigin: e.value.number })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>SPED</label>
                                <InputText
                                    disabled
                                    className="w-full"/>
                            </div>
                        </div>
                        <Divider>Unidades de medida</Divider>
                        <UnitSet2 set={unitSet} onChange={v => setUnitSet(v)}/>
                        <div className="mt-4">
                            <Button 
                                className="mr-2" 
                                label="Salvar"
                                loading={saving}/>
                            <Button 
                                label="Cancelar" 
                                outlined
                                type="button"
                                disabled={saving}
                                onClick={() => navigate(-1)}/>
                        </div>
                    </form>
                </If>
            </PageContent>
        </div>
    );
}

const CestDropdown = ({ ncm, value, onChange }) => {

    const api = useApi();
    const [ cestList, setCestList ] = useState(value ? [value] : []);
    const [ skipSearch, setSkipSearch ] = useState(!!value);

    useEffect(() => {
        if (skipSearch) {
            setSkipSearch(false);
            return;
        }
        if (ncm) {
            api.get('cest?limit=100&ncm=' + ncm.code).then(({ data: { data } }) => setCestList(data));
        } else {
            setCestList(null);
        }
    }, [ncm]);

    const itemTemplate = (item) => (
        <div>
            <div className="font-semibold">{item?.formattedCode}</div>
            <div className="text-xs" style={{ maxWidth: 300, whiteSpace: 'break-spaces' }}>{item?.description}</div>
        </div>
    );

    return (
        <Dropdown
            options={cestList}
            value={value}
            optionLabel="description"
            dataKey="code"
            itemTemplate={itemTemplate}
            disabled={!cestList || !cestList.length}
            onChange={e => onChange(e.value)}
            className="w-full"/>
    );
}

const UnitSet2 = ({ set = { ratios: [] }, onChange }) => {

    const [ edit, setEdit ] = useState();

    const add = () => {
        const newRatio = set.defaultUnit ? {} : { ratioValue: 1, default: true };
        setEdit(newRatio);
    }

    const remove = ratio => {
        const ratioList = set.ratios.filter(r => r.unit.symbol !== ratio.unit.symbol);
        onChange({ ...set, ratios: [ ...ratioList ] });
    }

    const ratioChanged = ratio => {
        if (ratio.default) {
            onChange({ ...set, defaultUnit: ratio.unit });
        } else {
            if (edit?.unit?.symbol) {
                const ratioList = set.ratios.filter(r => r.unit.symbol !== edit.unit.symbol);
                onChange({ ...set, ratios: [ ...ratioList, ratio ] });
            } else {
                const newRatioList = [ ...set.ratios, ratio ];
                onChange({ ...set, ratios: newRatioList });
            }
        }
        setEdit(undefined);
    }

    const list = set.defaultUnit ? [
        { unit: set.defaultUnit, ratioValue: 1, default: true },
        ...(set.ratios || [])
    ] : [];

    const defaultSymbol = set?.defaultUnit?.symbol;

    const actions = unit => (
        <>
            {!unit?.default && (
                <Button 
                    icon="pi pi-trash" 
                    className="mr-1" 
                    severity="secondary" 
                    title="Remover" 
                    type="button" 
                    onClick={() => remove(unit)}/>
            )}
            <Button 
                icon="pi pi-pencil" 
                title="Editar" 
                type="button" 
                onClick={() => setEdit(unit)}/>
        </>
    );

    const footer = (
        <tr className="flex justify-content-end	">
            <Button 
                severity="success"
                icon="pi pi-plus" 
                title="Adicionar" 
                type="button"
                onClick={add}/>
        </tr>
    );

    return (
        <>
            <EditRatioSidebar 
                ratio={edit} 
                defaultSymbol={defaultSymbol} 
                onHide={() => setEdit(undefined)}
                onChange={ratioChanged}/>
            <DataTable tableClassName="w-full" value={list} tableStyle={{ minWidth: '50rem' }} footer={footer}>
                <Column field="unit.description" header="Descrição"></Column>
                <Column field="unit.symbol" header="Símbolo"></Column>
                <Column body={ratio => ratio.ratioValue + ' ' + defaultSymbol} header="Razão"></Column>
                <Column body={actions} header="Ações" align='right'></Column>
            </DataTable>
            <div>
                
            </div>
        </>
    );
}

const EditRatioSidebar = ({ ratio, defaultSymbol, onChange, onHide }) => {

    const [ description, setDescription ] = useState(ratio?.unit?.description || '');
    const [ symbol, setSymbol ] = useState(ratio?.unit?.symbol || '');
    const [ ratioValue, setRatioValue ] = useState(ratio?.ratioValue || 0);

    useEffect(() => {
        if (ratio) {
            setDescription(ratio.unit?.description || '');
            setSymbol(ratio.unit?.symbol || '');
            setRatioValue(ratio.ratioValue || 0);
        }
    }, [ratio]);

    const save = () => {
        const unit = { symbol, description };
        onChange({ ratioValue, unit, default: ratio.default });
    }

    return (
        <Sidebar visible={ratio} position="right" onHide={onHide}>
            <div className="h-full flex flex-column">
                <h2>Unidade de medida</h2>
                <div className="formgrid grid">
                    <div className="field">
                        <label>Descrição</label>
                        <InputText 
                            className="w-full"
                            value={description}
                            onChange={e => setDescription(e.target.value)}/>
                    </div>
                    <div className="field">
                        <label>Símbolo</label>
                        <InputText 
                            className="w-full"
                            value={symbol}
                            maxLength={5}
                            onChange={e => setSymbol(e.target.value)}/>
                    </div>
                    <div className="field">
                        <label>Razão</label>
                        <div className="p-inputgroup">
                            <InputNumber 
                                locale="pt-BR" 
                                mode="decimal" 
                                maxFractionDigits={5}
                                value={ratioValue}
                                disabled={ratio?.default}
                                onChange={e => setRatioValue(e.value)}/>
                            {defaultSymbol && <span className="p-inputgroup-addon">{defaultSymbol}</span>}
                        </div>
                    </div>
                    <div className="field w-full">
                        <Button 
                            disabled={!description || !symbol || !ratioValue}
                            label="Salvar" 
                            className="w-full"
                            onClick={save}/>
                    </div>
                </div>
            </div>
        </Sidebar>
    );
}